export default __webpack_public_path__ + "static/media/image-chairsensor-w@3x.027db833.png";